import { useMemo } from 'react';

import { Step } from '../../step';

import { StepperTitle } from './StepperTitle';
import { StepperProps } from './type/Stepper.type';

export function BasicStepper({ title, maxStep = 0, currentStep }: Pick<StepperProps, 'title' | 'maxStep' | 'currentStep'>) {
  const steps = useMemo(() => {
    return Array.from({ length: maxStep ?? 0 });
  }, [maxStep]);

  return (
    <div className={'flex gap-normal-medium pt-normal-small'}>
      {title && <StepperTitle title={title} />}
      <div className={'flex gap-tiny-large'}>
        {steps.map((_, index) => {
          return (
            <Step
              key={`BasicStepper+${index}`}
              number={index + 1}
              variant={currentStep === index + 1 ? 'inProgress' : 'done'}
              aria-current={currentStep === index + 1 ? 'step' : undefined}
            />
          );
        })}
      </div>
    </div>
  );
}
